import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import chroma from 'chroma-js';
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { createGetTourneyDetailsOutbound, createGetUpcomingTourneysOutbound } from '../../api/outbound/commonOutbounds';
import { createJoinOutbound } from '../../api/outbound/lobbyOutbounds';
import { CountdownTimerDisplay } from '../../components/countdownTimer/countdownTimerDisplay';
import { BOLD_FONT_FAMILY, DEFAULT_FONT_FAMILY } from '../../constants/constants';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../redux/store';
import { LOBBY_NEXT_TOURNEY_DISPLAY_BORDER_COLOR, LOBBY_NEXT_TOURNEY_DISPLAY_TEXT_COLOR } from '../../styles/colors';
// Adds a little space to 'breathe' around the element's border
const PADDED_WRAPPER_CSS = css `
  padding: 2px;
`;
const BORDER_CSS = css `
  color: ${LOBBY_NEXT_TOURNEY_DISPLAY_TEXT_COLOR};
  border-radius: 10px;
  border: 2px solid ${LOBBY_NEXT_TOURNEY_DISPLAY_BORDER_COLOR};
  padding: 5px 10px;
`;
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0 20px;
`;
const TOURNEY_NAME_TYPOGRAPHY_CSS = css `
  font-family: ${BOLD_FONT_FAMILY};
`;
const BUTTON_ROW_CSS = css `
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 2px 5px;
`;
const BUTTON_CSS = css `
  color: ${LOBBY_NEXT_TOURNEY_DISPLAY_TEXT_COLOR};
  border-radius: 5px;
  border: 1px solid ${LOBBY_NEXT_TOURNEY_DISPLAY_BORDER_COLOR};
  background-color: rgba(0, 0, 0, 0.5);
  font-family: ${DEFAULT_FONT_FAMILY};
  padding: 5px;
  cursor: pointer;
  &:hover {
    background-color: ${chroma(LOBBY_NEXT_TOURNEY_DISPLAY_BORDER_COLOR).alpha(0.3).css()};
  }
`;
export const LobbyNextTourneyDisplayContainer = () => {
    const socketSend = useSocketSend();
    const nextTourney = useAppSelector((state) => state.common.nextTourney, shallowEqual);
    const onClickJoin = useCallback(() => {
        if (nextTourney && nextTourney.roomId !== -1) {
            socketSend(createJoinOutbound(nextTourney.roomId));
        }
    }, [nextTourney, socketSend]);
    const onClickAllUpcoming = useCallback(() => {
        socketSend(createGetUpcomingTourneysOutbound());
    }, [socketSend]);
    const onClickDetails = useCallback(() => {
        if (!nextTourney) {
            return;
        }
        socketSend(createGetTourneyDetailsOutbound(nextTourney.mttId));
    }, [nextTourney, socketSend]);
    return (_jsx("div", { css: PADDED_WRAPPER_CSS, children: _jsxs("div", { css: BORDER_CSS, children: [!!nextTourney && (_jsxs("div", { "aria-label": 'next tourney', css: CONTAINER_CSS, children: [_jsxs("div", { css: css `
                flex-grow: 1;
              `, children: [_jsx(Typography, { component: 'div', variant: 'subtitle2', "aria-hidden": true, children: "Next Tourney" }), _jsx(Typography, { component: 'div', variant: 'h6', css: TOURNEY_NAME_TYPOGRAPHY_CSS, children: nextTourney.tourneyName })] }), _jsx(Typography, { component: 'div', variant: 'h6', children: _jsx(CountdownTimerDisplay, { endTimestampMs: nextTourney.startTimestampMs }) }), nextTourney.roomId !== -1 && (_jsx("div", { children: _jsx(Button, { variant: 'contained', onClick: onClickJoin, children: "Join" }) }))] })), _jsxs("div", { css: BUTTON_ROW_CSS, children: [_jsx("button", { onClick: onClickAllUpcoming, css: BUTTON_CSS, children: "All Upcoming" }), nextTourney?.mttId !== undefined && (_jsx("button", { onClick: onClickDetails, css: BUTTON_CSS, children: "Tourney Details" }))] })] }) }));
};
